import { render } from "./meet-fashion-designers.vue?vue&type=template&id=5a55ffba&scoped=true"
import script from "./meet-fashion-designers.vue?vue&type=script&lang=js"
export * from "./meet-fashion-designers.vue?vue&type=script&lang=js"

import "./meet-fashion-designers.vue?vue&type=style&index=0&id=5a55ffba&scoped=true&lang=css"
import "./meet-fashion-designers.vue?vue&type=style&index=1&id=5a55ffba&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a55ffba"]])

export default __exports__